export const CREATE_INVOICE = "CREATE_INVOICE";
export const CANCEL_CREATE_INVOICE = "CANCEL_CREATE_INVOICE";
export const PATCH_EDIT_INVOICE = "PATCH_EDIT_INVOICE";

export const createInvoice = data => ({
  type: CREATE_INVOICE,
  data
});

export const cancelCreateInvoice = () => ({
  type: CANCEL_CREATE_INVOICE
});

export const patchEditInvoice = patch => ({
  type: PATCH_EDIT_INVOICE,
  patch
});



// WEBPACK FOOTER //
// ./src/actions/invoices.js